import { render, staticRenderFns } from "./LoryCarousel.vue?vue&type=template&id=f2e2a776&"
import script from "./LoryCarousel.vue?vue&type=script&lang=js&"
export * from "./LoryCarousel.vue?vue&type=script&lang=js&"
import style0 from "./LoryCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoryCarousel.vue"
export default component.exports